/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// material
import Button from 'material/ctas/button/button_container';
import Icon from 'material/graphic/icon/icon';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/imageapi/pagebuttons/pagebuttons_styles';



/* ========== ~~~~~~~~~~ IMAGE API : PAGE BUTTONS : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const PageButtons = (props) => {
    return (
        <div className={`${props.classes.pagebuttons} pagebuttons`} >
    		{props.pages && <Button type={`custom`} handleClick={(e) => props.pagination(true)} variant={`system`} name={`next`} text={`Next`} icon={<Icon name={`arrow-right`} />} iconRight />}
            {props.page > 1 && <Button type={`custom`} handleClick={(e) => props.pagination(false)} variant={`system`} name={`previous`} text={`Previous`} icon={<Icon name={`arrow-left`} />} />}
        </div>
    )
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(PageButtons);